import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import "./styles.less";

export default DatePicker;
